import { sdk } from '../utils/grappa';
export async function fetchCategory(categoryId, languageId) {
    const res = await sdk().CategoryPage({
        categoryId,
        pageUrl: window.location.toString(),
        languageId,
    });
    return res;
}
export async function fetchCategoryTree(languageId) {
    const res = await sdk().CategoryTree({
        pageUrl: window.location.toString(),
        languageId,
    });
    return res;
}
//# sourceMappingURL=category.js.map